import React, { useCallback, useEffect, useState } from 'react';
import { LegacyDeal, QuoteArticleHardware, QuoteArticleVirtual } from 'src/interfaces/api/Deal';
import moment from 'moment';
import jwtDecode from 'jwt-decode';
import DeliveryOrder from './DeliveryOrder';
import useDeliveryOrder from 'src/hooks/api/useDeliveryOrder';
import { PostDeliveryOrderBody } from 'src/interfaces/api/DeliveryOrder';
import { Box, Card, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const DeliveryOrderContainer = ({ location: { search }, history }) => {
  const [deal, setDeal] = useState<LegacyDeal>();
  const [contact, setContact] = useState<string>('');
  const [hardwareArticles, setHardwareArticles] = useState<QuoteArticleHardware[]>([]);
  const [virtualArticles, setVirtualArticles] = useState<QuoteArticleVirtual[]>([]);
  const [provider, setProvider] = useState<string>();
  const [authToken, setAuthToken] = useState<string>();
  const [isExpired, setIsExpired] = useState(false);

  const { create } = useDeliveryOrder();

  const handleCreate = useCallback(
    (deliveryOrder: PostDeliveryOrderBody) => {
      return create({ ...deliveryOrder, providerId: provider, token: authToken }, true);
    },
    [provider]
  );

  const goToSuccessPage = useCallback(() => {
    history.push('/informations?title=Bon de livraison&message=Votre bon de livraison a bien été créé&type=success');
  }, [history]);

  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    const token = searchParams.get('token');

    if (token) {
      const json: any = jwtDecode(token);
      const authToken: any = jwtDecode(json.token);

      setIsExpired(moment().isAfter(moment(authToken.expirationDate)));
      setAuthToken(json.token);
      setHardwareArticles(json.productsHardware);
      setVirtualArticles(json.productsVirtual);
      setContact(json.contact);
      setProvider(json.providerId);
      setDeal({
        id: json.id,
        name: '',
        dateCreate: moment().format(),
        customer: {
          installationSite: {
            socialReason: json.socialReason,
            telOffice: json.phoneNumber,
            postalCode: json.postalCode,
            adress: json.address,
          },
        },
      });
    }
  }, [search]);

  if (!deal) {
    return null;
  }

  if (isExpired) {
    return (
      <Box m={4} clone>
        <Card>
          <Box m={2}>
            <Typography gutterBottom variant='h5' component='h2'>
              Bon de livraison
            </Typography>
            <Alert severity='error'>Le lien est expiré</Alert>
          </Box>
        </Card>
      </Box>
    );
  }

  return (
    <DeliveryOrder
      deal={deal}
      hardwareArticles={hardwareArticles}
      virtualArticles={virtualArticles}
      contact={contact}
      onSaveDeliveryOrder={handleCreate}
      onSuccess={goToSuccessPage}
    />
  );
};

export default DeliveryOrderContainer;
